import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { MgmtDept, MgmtDeptRestriction } from '../models/mgmt-dept.model';
import { MgmtDeptGateway } from '../usecases/mgmt-dept.gateway';

@Injectable()
export class MgmtDeptService extends MgmtDeptGateway {
  constructor(private _http: HttpClient) {
    super();
  }

  getMgmtDept(mgmtDeptId: string): Observable<MgmtDept> {
    return this._http.get<MgmtDept>(`api/com/mgmt-depts/${mgmtDeptId}`);
  }

  updateMgmtDeptRestriction(mgmtDeptId: string, restriction: MgmtDeptRestriction): Observable<MgmtDept> {
    return this._http.put<MgmtDept>(`api/com/mgmt-depts/${mgmtDeptId}/restriction`, restriction);
  }
}
